<template>
    <v-dialog
        :value="showDialog"
        persistent
        max-width="550"
    >        
      <v-card>
        <v-card-title class="text-h5 blue darken-2 white--text">Saving your progress</v-card-title>
        <v-card-text dark>
            <div class='d-flex flex-column align-center justify-center'>
                <font-awesome-icon icon="spinner-third" size="3x" spin></font-awesome-icon>
                <span>Please wait a moment while we save your progress</span>
            </div>
            
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'SavingProgressDialog',
    props: {
        showDialog: Boolean
    }
  }
</script>